import React from 'react'
import { Button, Select } from 'antd'

const { Option } = Select

function SessionSidebar(props) {
    const {
        count,
        limit,
        userOptions,
        loadingUser,
        improver,
        submitting,
        onChangeImprover,
        onConfirm,
        onClear,
    } = props

    return (
        <div className='SessionSidebar'>
            <div className='SidebarTitle'>Xác nhận phiên</div>

            <div className='ItemCount'>{count}</div>
            <div className='ItemCountLabel'>item sẵn sàng ghi nhận</div>

            <div className='ImproverBlock'>
                <label className='ImproverLabel'>
                    Người hoàn thiện <span className='Required'>*</span>
                </label>
                <Select
                    className='ImproverSelect'
                    showSearch
                    allowClear
                    loading={loadingUser}
                    value={improver}
                    placeholder='— Chọn người hoàn thiện —'
                    filterOption={(input, option) =>
                        `${option.props.children}`.toLowerCase().indexOf(input.toLowerCase()) >= 0
                    }
                    onChange={onChangeImprover}
                >
                    {userOptions.map(item => (
                        <Option key={item.value} value={item.value}>{item.name}</Option>
                    ))}
                </Select>
            </div>

            <Button
                type='primary'
                size='large'
                className='ConfirmButton'
                loading={submitting}
                disabled={!improver || !count || submitting}
                onClick={onConfirm}
            >
                Xác nhận hoàn thiện
            </Button>

            <div className='ClearSession' onClick={onClear}>Xóa danh sách phiên</div>

            <div className='SidebarFooter'>
                <div>Trần phiên {count}/{limit}</div>
                {
                    improver
                        ? <div>Sẽ ghi nhận cho: <strong>{improver}</strong></div>
                        : <div className='text-danger'>Chưa chọn người hoàn thiện</div>
                }
            </div>
        </div>
    )
}

export default SessionSidebar
